import { render, staticRenderFns } from "./LivingOptionProperties.vue?vue&type=template&id=0273fe28&scoped=true&"
import script from "./LivingOptionProperties.vue?vue&type=script&lang=js&"
export * from "./LivingOptionProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273fe28",
  null
  
)

export default component.exports